var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomInputSelectJson',{staticClass:"area-selector",attrs:{"value":_vm.value,"options":_vm.availableZones},on:{"input":function($event){return _vm.$emit("input", $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }